import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';

import * as moment1 from 'moment';
import {extendMoment} from 'moment-range';

const moment = extendMoment(moment1);

@Injectable({
  providedIn: 'root'
})

export class UtilsService {
  isOnline: Observable<boolean>;

  constructor() {
  }

  getUsuario() {
    return JSON.parse(localStorage.getItem('usuario'));
  }

  getUsuarioPapel() {
    const usuarioPapeis = this.getUsuario()['papeis'];
    if (usuarioPapeis['super'] === 1) {
      return 'super';
    } else if (usuarioPapeis['diretor'] === 1) {
      return 'diretor';
    } else if (usuarioPapeis['supervisor'] === 1) {
      return 'supervisor';
    } else if (usuarioPapeis['gerente'] === 1) {
      return 'gerente';
    } else if (usuarioPapeis['vendedor'] === 1) {
      return 'vendedor';
    }
  }

  mobileCheck() {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
        .test(navigator.userAgent)) {
      return true;
    }
  }

  rangeArray(dataInicial, dataFinal, periodo, format?) {
    const range1 = moment.range(dataInicial, dataFinal);
    const array = Array.from(range1.by(periodo));
    if (!format) {
      return array;
    } else {
      return array.map(m => {
        if (isNaN(Number(m.format(format).toString()))) {
          return m.format(format);
        } else {
          return Number(m.format(format));
        }
      }).filter((value, index, self) => {
        return self.indexOf(value) === index;
      });
    }
  }

  calcTotalFromArray(array, type) {
    let arrayLength = array.length;
    const sum = array.reduce((a, b) => {
      if (b == null || b === '' || isNaN(b)) {
        b = 0;
        arrayLength = arrayLength - 1;
      }
      return +(a + b).toFixed(10);
    }, 0);
    if (type === 'soma') {
      return sum;
    }
    if (type === 'media') {
      return sum / (arrayLength ? arrayLength : 1);
    }
  }

  getPropObjFromArray(array, propToGet, propValue, value) {
    let propValueFounded = null;
    array.map(obj => {
      if (obj[propValue] === value) {
        propValueFounded = obj[propToGet];
      }
    });
    return propValueFounded;
  }

  sortByNumericProperty(array, prop) {
    return array.sort((obj1, obj2) => {
      if (obj1[prop] > obj2[prop]) {
        return 1;
      }

      if (obj1[prop] < obj2[prop]) {
        return -1;
      }

      return 0;
    });
  }

  groupArrayByProperty(array, prop, propToPush?) {
    return array.reduce(function (obj1, obj2) {
      obj1[obj2[prop]] = obj1[obj2[prop]] || [];
      if (obj1[obj2[prop]].indexOf(obj2[propToPush]) === -1) {
        obj1[obj2[prop]].push(obj2[propToPush]);
      }
      return obj1;
    }, {});
  }

  checkOnline() {
    this.isOnline = Observable.merge(
      Observable.of(navigator.onLine),
      Observable.fromEvent(window, 'online').map(() => true),
      Observable.fromEvent(window, 'offline').map(() => false));
    return this.isOnline;
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  removeAccents(string) {
    return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
}
